import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { Moon } from "lucide-react";

const DREAM_CHART = [
  { no: 1, dream: "Quarrel between husband and wife", direct: "03, 08, 13, 37, 40, 73", house: "", ending: "3" },
  { no: 2, dream: "Erotic dream", direct: "17, 40, 53, 59, 60, 83", house: "", ending: "" },
  { no: 3, dream: "Bathing in the open", direct: "08, 18, 28, 48, 78, 98", house: "", ending: "8" },
  { no: 4, dream: "Travelling", direct: "08, 14, 18, 52, 64, 68, 74, 78, 98", house: "", ending: "8" },
  { no: 5, dream: "Travelling in an aeroplane", direct: "23, 43, 53, 63, 68, 73, 83, 93", house: "", ending: "3" },
  { no: 6, dream: "Taking a walk", direct: "", house: "", ending: "0, 1" },
  { no: 7, dream: "Studying", direct: "", house: "", ending: "5" },
  { no: 8, dream: "Corpse", direct: "", house: "9", ending: "9" },
  { no: 9, dream: "Playing", direct: "00, 27, 40, 50, 57, 60", house: "", ending: "" },
  { no: 10, dream: "Talking over the phone", direct: "98, 96, 94", house: "", ending: "" },
  { no: 11, dream: "Eating", direct: "01, 02, 05, 15, 16, 45, 75, 85, 95", house: "", ending: "" },
  { no: 12, dream: "Breast Feeding", direct: "02, 03, 05, 12, 20, 52, 53", house: "", ending: "" },
  { no: 13, dream: "Male", direct: "6", house: "6", ending: "" },
  { no: 14, dream: "Female", direct: "5", house: "5", ending: "" },
  { no: 15, dream: "Child", direct: "2, 3", house: "2, 3", ending: "" },
  { no: 16, dream: "Police", direct: "7, 87, 8", house: "", ending: "" },
  { no: 17, dream: "Wild Pig", direct: "46", house: "", ending: "" },
  { no: 18, dream: "Snake or ilea fish", direct: "09, 17, 37, 57, 77, 99", house: "", ending: "7" },
  { no: 19, dream: "Cow, goat or buffalo", direct: "12, 18, 19, 22, 24, 34, 42, 54, 72, 74, 84, 94, 97", house: "", ending: "" },
  { no: 20, dream: "Cow", direct: "4", house: "4", ending: "" },
  { no: 21, dream: "Tiger", direct: "9", house: "9", ending: "" },
  { no: 22, dream: "Dog", direct: "4, 5, 6", house: "4", ending: "" },
  { no: 23, dream: "Horse", direct: "8", house: "8", ending: "" },
  { no: 24, dream: "Bird", direct: "2", house: "2", ending: "" },
  { no: 25, dream: "Elephant", direct: "9", house: "9", ending: "" },
  { no: 26, dream: "Snail", direct: "0", house: "0", ending: "0" },
  { no: 27, dream: "Turtle", direct: "9", house: "9", ending: "" },
  { no: 28, dream: "Crab", direct: "6, 2", house: "6", ending: "2" },
  { no: 29, dream: "Spider", direct: "6, 12", house: "", ending: "" },
  { no: 30, dream: "Honey bee", direct: "74, 24, 14, 04, 94", house: "", ending: "4" },
  { no: 31, dream: "Insect", direct: "37, 21", house: "", ending: "" },
  { no: 32, dream: "Sour fruits", direct: "00, 03, 11, 12, 13, 23, 32, 43, 53, 63, 70, 73, 79, 93", house: "", ending: "" },
  { no: 33, dream: "Paddy field", direct: "24, 38, 52, 54, 64, 68, 74", house: "", ending: "" },
  { no: 34, dream: "Pumpkin", direct: "28, 35, 48, 53, 58, 68, 78, 88, 98", house: "", ending: "" },
  { no: 35, dream: "Bamboo", direct: "0, 1", house: "", ending: "" },
  { no: 36, dream: "Big Tree", direct: "8, 9", house: "", ending: "" },
  { no: 37, dream: "Small tree", direct: "2, 3, 8", house: "", ending: "" },
  { no: 39, dream: "Banana", direct: "11, 3", house: "", ending: "" },
  { no: 40, dream: "Jackfruit", direct: "4", house: "", ending: "4" },
  { no: 41, dream: "Papaya", direct: "1, 12", house: "1", ending: "" },
  { no: 42, dream: "Orange", direct: "8, 9", house: "", ending: "" },
  { no: 43, dream: "Chilli", direct: "1, 2", house: "1", ending: "2" },
  { no: 44, dream: "Bamboo Shoot", direct: "1, 11", house: "1", ending: "1" },
  { no: 45, dream: "Tool used to cut wood", direct: "1, 57, 61, 67", house: "", ending: "6" },
  { no: 46, dream: "Tools : cutter, chopper, hammer", direct: "07, 17, 27, 47, 67, 71, 87", house: "", ending: "7" },
  { no: 47, dream: "An event or a shopping place", direct: "18, 28, 38, 52, 58, 62", house: "", ending: "8" },
  { no: 48, dream: "Money", direct: "00, 14, 15, 20, 25, 35, 50", house: "", ending: "0, 5" },
  { no: 49, dream: "Small water body", direct: "00, 01, 02, 80, 90", house: "4, 7", ending: "0" },
  { no: 50, dream: "Tools : cutter, chopper, hammer", direct: "07, 17, 27, 47, 67, 71, 87", house: "", ending: "7" },
  { no: 51, dream: "An event or a shopping place", direct: "18, 28, 38, 52, 58, 62", house: "4, 7", ending: "0" },
  { no: 52, dream: "Footpath or a road made of bricks", direct: "19, 61, 71, 91", house: "", ending: "" },
  { no: 53, dream: "Automobile : 4 wheeler", direct: "21, 24, 54, 62, 64", house: "8", ending: "4" },
  { no: 54, dream: "Automobile : 2/3 wheeler", direct: "52, 53, 54, 58, 60, 62, 68", house: "", ending: "" },
  { no: 55, dream: "God", direct: "09, 13, 29, 89", house: "", ending: "" },
  { no: 56, dream: "Book, pen, paper", direct: "00, 02, 05", house: "0", ending: "3" },
  { no: 57, dream: "Earthquake", direct: "00, 07, 08, 14, 41, 75, 95", house: "", ending: "" },
  { no: 58, dream: "Ghost or apparition", direct: "52, 54, 58, 62, 64, 68", house: "9", ending: "9" },
  { no: 59, dream: "Oven, kiln, fireplace", direct: "12, 31, 63, 66, 68", house: "", ending: "" },
  { no: 60, dream: "Fire", direct: "", house: "", ending: "0" },
  { no: 61, dream: "Hand Pump", direct: "2, 3, 7, 17, 18, 20, 71", house: "", ending: "" },
  { no: 62, dream: "Water Carrier", direct: "8", house: "8", ending: "8" },
  { no: 63, dream: "Lake", direct: "6", house: "", ending: "" },
  { no: 64, dream: "Boat", direct: "3", house: "", ending: "" },
  { no: 65, dream: "Rice Chopper", direct: "8", house: "", ending: "" },
  { no: 66, dream: "Big river", direct: "8", house: "", ending: "" },
  { no: 67, dream: "Cooking pan", direct: "2", house: "", ending: "" },
  { no: 69, dream: "Shoe", direct: "8", house: "", ending: "" },
  { no: 70, dream: "Train", direct: "9", house: "", ending: "" },
  { no: 71, dream: "Temple", direct: "1, 2, 9", house: "", ending: "" },
  { no: 72, dream: "Umbrella", direct: "1", house: "1", ending: "1" },
  { no: 73, dream: "Pencil", direct: "7, 77, 79", house: "7", ending: "7" },
];

export default function DreamNumber() {
  return (
    <Layout>
      <Seo
        title="Dream Number Chart | Night Teer Dream Number List"
        description="Night Teer Dream Number chart with Direct, House and Ending numbers for common dreams. Provided for informational and entertainment purposes only."
        path="/dream-number"
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="font-oswald text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 flex items-center gap-3">
          <Moon className="text-indigo-600" size={34} /> Dream Number Chart
        </h1>
        <p className="mt-3 text-slate-600 leading-relaxed">
          Find the numbers associated with common dreams below. This dream number chart lists the Direct, House and
          Ending numbers for each dream. It is provided purely for informational and entertainment purposes.
        </p>

        <div className="mt-8 w-full overflow-x-auto rounded-xl border border-slate-200 shadow-sm" data-testid="dream-chart-wrapper">
          <table className="w-full min-w-[560px] text-left border-collapse" data-testid="dream-chart-table">
            <thead>
              <tr className="bg-blue-500 text-white">
                <th className="px-2 sm:px-3 py-2.5 text-xs sm:text-sm font-bold border-r border-white/30 text-center w-12">Sl.no</th>
                <th className="px-2 sm:px-3 py-2.5 text-xs sm:text-sm font-bold border-r border-white/30">Dream</th>
                <th className="px-2 sm:px-3 py-2.5 text-xs sm:text-sm font-bold border-r border-white/30">Direct</th>
                <th className="px-2 sm:px-3 py-2.5 text-xs sm:text-sm font-bold border-r border-white/30 text-center w-16">House</th>
                <th className="px-2 sm:px-3 py-2.5 text-xs sm:text-sm font-bold text-center w-16">Ending</th>
              </tr>
            </thead>
            <tbody>
              {DREAM_CHART.map((r) => (
                <tr key={r.no} className="odd:bg-white even:bg-slate-50 border-t border-slate-200" data-testid={`dream-row-${r.no}`}>
                  <td className="px-2 sm:px-3 py-2 text-sm text-slate-500 text-center border-r border-slate-100">{r.no}</td>
                  <td className="px-2 sm:px-3 py-2 text-sm font-semibold text-slate-900 border-r border-slate-100">{r.dream}</td>
                  <td className="px-2 sm:px-3 py-2 text-sm font-medium text-slate-700 border-r border-slate-100">{r.direct || "—"}</td>
                  <td className="px-2 sm:px-3 py-2 text-sm font-bold text-indigo-700 text-center border-r border-slate-100">{r.house || "—"}</td>
                  <td className="px-2 sm:px-3 py-2 text-sm font-bold text-indigo-700 text-center">{r.ending || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 rounded-2xl bg-slate-900 p-5 text-sm text-slate-300 leading-relaxed">
          <span className="font-bold text-white">Disclaimer:</span> This dream number chart is for informational and
          entertainment purposes only. We do not guarantee any winning numbers or predictions.
        </div>
      </div>
    </Layout>
  );
}
